/**
 *
 * TravelInformation
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cs from 'classnames';
import FlightItineraryDetails from '../../Features/flights/components/FlightItineraryDetails';
import Card from '../Card';
import HotelSelectFare from '../../Features/hotels/components/HotelSelectFare';

const TravelInformation = ({ availability, className }) => {
  const { engine, selectedSegment, flightPrice } = availability;

  if (engine === 'hotel-details') {
    return (
      <div className={cs(className)}>
        <img
          style={{ maxWidth: '100%' }}
          src={availability.hotels.property.images[0].imageUrl}
          alt="imagen hotel"
        />
        <HotelSelectFare
          className="fare"
          price={availability.hotelInformation.packagePrice.finalPrice}
          details={availability.hotelInformation.details}
          currency={availability.hotelInformation.packagePrice.currency}
          localCurrency={
            availability.hotelInformation.localPrice &&
            availability.hotelInformation.localPrice.currency
          }
          localPrice={
            availability.hotelInformation.localPrice &&
            availability.hotelInformation.localPrice.finalPrice
          }
          isCheckout
        />
      </div>
    );
  }

  // Obtener validating carrier, códigos de origen y destino
  const validatingCarrier = flightPrice?.validatingCarrier;
  const idaOriginCode = selectedSegment.ida.item.departureData?.airport?.code;
  const idaDestinationCode = selectedSegment.ida.item.arrivalData?.airport?.code;
  const vueltaOriginCode = selectedSegment.vuelta.item?.departureData?.airport?.code;
  const vueltaDestinationCode = selectedSegment.vuelta.item?.arrivalData?.airport?.code;

  return (
    <>
      <Card header="Detalle de ida" context="default" borderRadius="square">
        <div
          className={`content no-padding margin background-white ${className}`}>
          <FlightItineraryDetails
            baggage={selectedSegment.ida.item.baggage}
            duration={selectedSegment.ida.item.duration}
            scales={selectedSegment.ida.item.scales}
            segments={selectedSegment.ida.item.segments}
            validatingCarrier={validatingCarrier}
            destinationCode={idaDestinationCode}
            originCode={idaOriginCode}
          />
        </div>
      </Card>

      {selectedSegment.vuelta.item && (
        <Card
          header="Detalle de vuelta"
          context="default"
          borderRadius="square">
          <div
            className={`content no-padding margin background-white ${className}`}>
            <FlightItineraryDetails
              baggage={selectedSegment.vuelta.item.baggage}
              duration={selectedSegment.vuelta.item.duration}
              scales={selectedSegment.vuelta.item.scales}
              segments={selectedSegment.vuelta.item.segments}
              validatingCarrier={validatingCarrier}
              destinationCode={vueltaDestinationCode}
              originCode={vueltaOriginCode}
            />
          </div>
        </Card>
      )}
    </>
  );
};

TravelInformation.propTypes = {
  availability: PropTypes.object,
  className: PropTypes.string
};

export default styled(TravelInformation)`
  display: flex;
  justify-content: center;
  flex: 1;
  margin: 0 auto;
  flex-direction: column;

  .fare {
    margin-top: 20px;
  }
`;
